import React, {Component} from 'react'
import CartContext from './CartContext'
import AddToCartPrompt from '../AddToCart/addToCartPrompt'

const Negosyo = require('../../../lib/negosyo')

class CartProvider extends Component {
	state = {
		cartId:null,
		cartCount:0,
		gettingCartId:true,
		timeOutRef:null,
		promptProduct: null, // { name, image, quantity }
		promptInterval: null,
		promptHovered: false,
		promptSeconds: 0,
		addToCartDisabled: false
	}

	// Note: to always get the updated values
	getCartInfo = () => ({
		cartId: this.state.cartId,
		cartCount: this.state.cartCount,
		gettingCartId: this.state.gettingCartId,
	})

	handleAddToCartDisable = (value) => {
		this.setState({addToCartDisabled: value})
	}

	showPrompt = (productName, productImage, quantity) => {
		// Clear existing countdown
		clearInterval(this.state.promptInterval);
		this.setState({promptProduct: null, promptSeconds: 0, promptInterval: null})

		// Countdown to hide propmt
		const interval = setInterval(() => {
			// If mouse is hovering the propmpt, pause the countdown

			if (!this.state.promptHovered) {
				const newSeconds = this.state.promptSeconds - 1;

				if (newSeconds === 0) {
					this.resetPrompt();
				} else {
					this.setState({ promptSeconds: newSeconds })
				}
			}
		}, 1000)

		this.setState({
			promptProduct: { name: productName, image: productImage, quantity},
			promptInterval: interval,
			promptSeconds: 5
		})
	}

	resetPrompt = () => {
		clearInterval(this.state.promptInterval);
		this.setState({
			promptSeconds: 0,
			promptInterval: null,
			promptProduct: null,
			promptHovered: false
		})
	}

	updateCartCount = (cartCount, cartId) => {
		localStorage.setItem("mcart", JSON.stringify({ cartId, cartCount }));
		this.setState({cartCount:cartCount, cartId:cartId})
	}

	/*
	 * This is called when there is no cart id but user tried to:
	 * - add a product to cart
	 * - go to /cart page and load cart items
	 */
	initiateRetry = () => {
		return new Promise(resolve => {
			this.setState( prevState => ({
				gettingCartId:true
			}), ()=>{
				this.getCartId(5, 100)
				resolve(true)
			})
		})
	}

	/*
	 * This is called after a successful checkout
	 */
	resetProvider = () => {
		//goes back to square one(initial state of cartProvider), should be called only after a checkout
		//to reset the cartProvider to be sure there's no holdover data from the previous cartId
		this.setState({
			cartId:null,
			cartCount:0,
			gettingCartId:true,
		}, ()=> {
			localStorage.removeItem('mcart')
			this.getCartId(5, 100);
		}) //timeOutRef isn't reset just in case a timeOut is still there
	}

	getCartId = async (maxRetry = 5, retryDelay=100, fail=false) => {

		try {
			// Conflict with old format(?)
			const cartData = localStorage.getItem("mcart");
			if (cartData) {
				const { cartId, cartCount } = JSON.parse(cartData);
				this.setState({ cartId, cartCount, gettingCartId: false });
				return;
			}
		} catch(carterr) {

		}

		if (maxRetry > 0) {
			try {
				const response = await Negosyo.requestCartId(fail);

				if (response.status === "OK") {
					const cartId = response.data;

					// Since this is a new cart id, the total would always start at 0
					localStorage.setItem("mcart", JSON.stringify({ cartId, cartCount: 0 }));
					this.setState({ cartId, cartCount: 0, gettingCartId: false });
				} else {
					throw new Error("Failed to get cart data");
				}
			} catch (error) {
				//not sure what would cause api to send an error but its here just in case
				const temp = setTimeout(() => {
					this.getCartId(maxRetry - 1, retryDelay * 2, fail);
				}, retryDelay);

				this.setState({ timeOutRef: temp });
			}
		} else {
			this.setState({ gettingCartId: false })
		}
	}


	componentDidMount() {
		this.getCartId(5, 100);

	}
	componentWillUnmount() {
		clearTimeout(this.state.timeOutRef);
	}

	render() {
		const {
			getCartInfo,
			handleAddToCartDisable,
			showPrompt,
			updateCartCount,
			initiateRetry,
			resetProvider
		} = this
		const {
			cartId,
			cartCount,
			gettingCartId,
			addToCartDisabled
		} = this.state
		const {
			children
		} = this.props
		return (
			<CartContext.Provider
				value={{
					cartId,
					cartCount,
					getCartInfo,
					handleAddToCartDisable,
					addToCartDisabled,
					showPrompt,
					updateCartCount,
					gettingCartId,
					initiateRetry,
					resetProvider
				}}
			>
				<AddToCartPrompt
					promptVisible={this.state.promptProduct !== null && this.state.promptSeconds > 0}
					product={this.state.promptProduct}
					handleHover={value => this.setState({promptHovered: value})}
					closePrompt={this.resetPrompt}
				/>
				{children}
			</CartContext.Provider>
		)
	}
}

export default CartProvider

